import CompleteIcon from "assets/icons/loyalty/loyalty-rank-complete.svg?react";
import ProgressIcon from "assets/icons/loyalty/loyalty-rank-progress.svg?react";
import CloseIcon from "assets/icons/loyalty/loyalty-rank-close.svg?react";
import { StatusRank } from "./types";

type LoyaltyRankStatusProps = {
  status: StatusRank;
};

const LoyaltyRankStatus = ({ status }: LoyaltyRankStatusProps) => {
  const icons: Record<StatusRank, React.FC> = {
    complete: CompleteIcon,
    close: CloseIcon,
    progress: ProgressIcon,
  };

  const Icon = icons[status];

  if (!Icon) {
    return null;
  }

  return <Icon />;
};

export default LoyaltyRankStatus;
